<template>
  <div>
    <CreateNavBar/>

    <!-- TODO: smooth switch rendering -->
    <div v-if="!isValidInvite">
      <br/><br/>
      <Page404 :image="pageImage"
        :message="inviteCheckingMessage"
        :isShowRequestNew="isShowRequestNew"/>
    </div>

    <div v-else class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="isRequestInProgress"/>
        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width"/>
          </div>

          <div class="col-sm form-container">
            <form @submit.prevent="submit" id="form-create" novalidate>
              <div class="type-of-account">
                <p>Choose type of account</p>

                <!-- <div class="form-check">
                  <input
                    class="form-check-input"
                    v-model="formType"
                    type="radio"
                    name="for-create-account"
                    id="for-individual-create"
                    value="individual"
                    disabled
                  >
                  <label class="form-check-label" for="for-individual-create">YeyPass for me</label>
                  <small class="form-text text-muted radio-option-help">
                    Choose this if you will use YeyPass for yourself.
                  </small>
                </div> -->

                <div class="form-check">
                  <input
                    class="form-check-input"
                    v-model="formType"
                    type="radio"
                    name="for-create-account"
                    id="for-business-create"
                    value="business"
                  >
                  <label class="form-check-label" for="for-individual-create">YeyPass for Business</label>
                  <small class="form-text text-muted radio-option-help">
                    Choose this if you will use YeyPass for your establishments.
                    <br>e.g Buildings, Office, Hotels, Condos, Schools and etc.
                  </small>
                </div>
              </div>

              <!-- For Establishment Owners -->
              <div id="establishment-signup-form" v-if="formType === 'business'">
                <InputComponent
                  type="text"
                  for="input-company-name"
                  label_text="Business Name"
                  attribute="Business Name"
                  placeholder="CompanyXYZ"
                  v-model="form.business.company_name"
                  :v="$v.form.business.company_name"
                />
                <small
                  v-if="fetchError && fetchError.account === 'business' && fetchError.error_type == 'misc'"
                  data-type="message"
                  class="form-text text-muted error-message"
                  v-html="fetchError.error"
                ></small>

                <InputComponent
                  type="email"
                  for="input-company-email"
                  label_text="Email Address"
                  attribute="Email Address"
                  placeholder="your@awesomecompany.com"
                  v-model="form.business.email_address"
                  :v="$v.form.business.email_address"
                />
                <small
                  v-if="fetchError && fetchError.account === 'business' && fetchError.error_type == 'email'"
                  data-type="message"
                  class="form-text text-muted error-message"
                  v-html="fetchError.error">
                </small>

                <div class="form-group password">
                  <label for="input-company-password">Password</label>
                  <input
                    v-model="form.business.password"
                    data-vv-name="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    :v="$v.form.business.password"
                    @input="$v.form.business.password.$touch()">
                  <!--small class="form-text text-muted password-help">
                  Password should be at least 8 characters in length.
                  Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                  </small-->
                  <div v-if="$v.form.business.password.$dirty">
                    <small
                      class="form-text text-muted error-message"
                      v-if="!$v.form.business.password.required"
                    >Password must not be empty.</small>
                    <small
                      class="form-text text-muted password-help error-message"
                      v-if="!$v.form.business.password.minLength"
                    >Password should be at least 8 characters in length.
                      <br>Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                    </small>
                  </div>
                  <small
                    v-if="fetchError && fetchError.account === 'business' && fetchError.error_type == 'password'"
                    data-type="message"
                    class="form-text text-muted error-message"
                    v-html="fetchError.error"
                  ></small>
                </div>

                <InputComponent
                  type="text"
                  for="input-contact-person"
                  label_text="Company Representative (Full Name)"
                  attribute="Company Representative"
                  placeholder="James Dean"
                  v-model="form.business.company_details.contact_person"
                  :v="$v.form.business.company_details.contact_person"
                />

                <InputComponent
                  type="text"
                  for="input-role"
                  label_text="Company Representative Role"
                  attribute="Company Representative Role"
                  placeholder="Admin Officer"
                  v-model="form.business.company_details.role_in_company"
                  :v="$v.form.business.company_details.role_in_company"
                />
              </div>
              <!-- Establishment Form Content Ends Here -->

              <!-- Submit Button -->
              <div class="text-center">
                <button type="submit" class="btn btn-primary">Sign Up</button>
              </div>
            </form>

            <small class="form-text text-muted text-center">
              By signing up, you agree with our
              <a class="simple-link" href="/tos">Terms</a> and
              <a class="simple-link" href="/privacy">Privacy Policy</a>.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  REGISTER, UPDATE_USER_REQUEST_ACCESS_DATE
} from '@/store/types/actions.type'

import { required, email, minLength } from 'vuelidate/lib/validators'

import CreateNavBar from '@/components/common/CreateNavBar'
import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'
import InputComponent from '@/components/form/InputComponent'
import Page404 from '@/components/Page404'

import { DateTimeHelper } from '@/api/helper/DateTimeHelper'
import {
  ASSET_CREATE_ACCOUNT,
  LINK_OPENING,
  LINK_INVALID
} from '@/api/constants/ImageAssets'
import { AuthService } from '@/api/AuthService'
import { APIService } from '@/api/APIService'

const auth = new AuthService()
const api = new APIService()
const date = new DateTimeHelper()

export default {
  components: {
    CreateNavBar,
    CreateTitle,
    CreatePageImage,
    InputComponent,
    Loader,
    Page404
  },
  data() {
    return {
      page_title: 'Create Account',
      image: ASSET_CREATE_ACCOUNT,
      formType: 'business',
      form: {
        business: {
          email_address: '',
          password: '',
          account_type: 'business',
          company_name: '',
          company_details: {
            contact_person: '',
            role_in_company: ''
          }
        }
      },
      requestId: '',
      requestCompanyName: '',
      inviteCheckingMessage: '',
      isValidInvite: false,
      isShowRequestNew: false,
      error: { message: '' },
      pageImage: LINK_OPENING
    }
  },
  validations: {
    form: {
      business: {
        email_address: { required, email },
        password: { required, minLength: minLength(8) },
        company_name: { required },
        company_details: {
          contact_person: { required },
          role_in_company: { required }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['fetchError', 'registerFields', 'isRequestInProgress', 'currentUser'])
  },
  mounted() {
    // do check if there's already someone loggedIn
    if(auth.getUserId()) {
      this.$router.push('/dashboard')
    } else {
      this.checkLink()

      this.pageOrigin = this.$route.query.page_origin
      if (this.pageOrigin) {
        this.route = `/upload-selfie?page_origin=${this.pageOrigin}`
      }
    }
  },
  methods: {
    checkLink() {
      const self = this
      const link = this.$route.query.l
      this.inviteCheckingMessage = 'Please wait, checking invite link...'
      if(link) {
        api.getUserRequestByLink(link).then(d => {
          setTimeout(function(){
            if(d.length === 0) {
              self.showNotValidInvite()
            } else {
              const dateValidity = d[0].date_validity
              const dateAccessed = d[0].date_accessed
              self.requestId = d[0].id
              self.requestCompanyName = d[0].company_name
              self.checkValidity(dateValidity, dateAccessed)
            }
          }, 3000)
        }).catch(e => { self.error.message = e })
      } else {
        self.redirectToNotFound()
      }
    },
    checkValidity(dateValidity, dateAccessed) {
      if (!date.compareEpochDateToday(dateValidity)) {
        this.showLinkExpired()
      } else {
        if(dateAccessed === 0) {
          this.isValidInvite = true
        } else {
          this.showNotValidInvite()
        }
      }
    },
    showLinkExpired() {
      this.isValidInvite = false
      this.isShowRequestNew = true
      this.pageImage = LINK_INVALID
      this.inviteCheckingMessage = 'Link was expired, please request a new one'
    },
    showNotValidInvite() {
      this.isValidInvite = false
      this.isShowRequestNew = true
      this.pageImage = LINK_INVALID
      this.inviteCheckingMessage = 'Link is not valid, please request a new one'
    },
    submit() {
      if (this.formType === 'business') {
        this.$v.form.business.$touch()
        if (!this.$v.form.business.$invalid) {
          return this.postFields()
        }
      }
    },
    postFields() {
      let self = this
      let fields = {}
      if (this.formType === 'business') {
        const email = this.form.business.email_address
        this.form.business.email_address = email.toLowerCase()

        const businessFields = {
          ...this.form.business, account_type: this.formType
        }
        fields = businessFields
      }

      this.$store.dispatch(REGISTER, fields)
      .then(data => { self.updateAccessDate() })
      .catch(err => { self.error.message = err })
    },
    updateAccessDate() {
      const self = this
      this.$store.dispatch(UPDATE_USER_REQUEST_ACCESS_DATE, this.requestId)
      .then(data => { self.redirectToPage() })
      .catch(err => { self.error.message = err })
    },
    redirectToPage() {
      if (this.formType === 'business') {
        this.$router.push(`/create-profile/business/${this.currentUser.id}/info`)
      } else {
        this.$router.push(this.route)
      }
    }
  }
}
</script>

<style>
  @import '../assets/styles/form-style-1.css';

  .individual-request-link {
    margin-top: 30px;
    margin-bottom: 10px;
    margin-left: 8px;
    border: none;
    background-color: #ffd630;
    color: #00386a;
    font-family: 'HKGrotesk-Bold', Helvetica, sans-serif;
    font-size: 16px;
    min-width: 200px;
    border-radius: 3px;
    padding: 10px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/containers/CreateAccountByInvite.vue